import { ThemeProvider } from "@material-ui/core";
import React from "react";
import { GOOGLE_FONT_URL } from "../../../../data/StringConstants";
import customTheme from "../../../../theme/customTheme/customTheme";

/**
 * A parent component meant to wrap each React View and provide them with a consistent theme.
 * The <ThemeProvider> component is part of Material-UI and is meant to be applied at the root of your
 * React component tree. Since we're building individual components, we can't simply apply this once around something
 * like an <App> component.
 *
 * The font is currently referenced here instead of the .cshtml in order to allow the font to be rendered in Storybook.
 * @returns A parent component meant to wrap each React View and provide them with a consistent theme.
 */
export default function LibraryAwareTheme(props) {
	return (
		<ThemeProvider theme={customTheme}>
			<link
				rel="stylesheet"
				href={GOOGLE_FONT_URL}
			/>
			{props.children}
		</ThemeProvider>
	);
}
